module.exports = __webpack_public_path__ + "img/admin.96161938.png";